module.exports = __webpack_public_path__ + "img/pen-white.b85e6a9c.svg";